export const endpoints = {
  auth:{
    login: "/auth/login"
  },

  companies: {
    list: "/companies",
    create: "/companies",
    byId: (id) => `/companies/${id}`,
    update: (id) => `/companies/${id}`,
  },

  padlock: {
    list: "/padlock",
    byId: (id) => `/padlock/${id}`,
    dashboard: (id) => `/padlock/${id}/dashboard`,
    latestLocations: "/padlock/latest-locations",
    permissionsByPadlock: (id) => `/padlock/${id}`,
    summary: "/padlock/summary",
    updateStatus: (id) => `/padlock/${id}/status`,
    openEvents: (id) => `/padlock/${id}/open-events`,
    route: (id) => `/padlock/${id}/route`,
    routeBasic: (id) => `/padlock/${id}/route/basic`,
    verifiedTransit: (id) => `/padlock/${id}/verified-transit`,
  },

  users: {
    list: "/users",
    byId: (id) => `/users/${id}`,
    create: "/users",
    update: (id) => `/users/${id}`,
  },

  route: (id) => `/padlock/${id}/route`,

  permissions: {
    list: "/permissions",
    create: "/permissions",
    byIds: (padlockId, userId) => `/permissions/${padlockId}/${userId}`, 
  },
};
